import React, { useState } from "react";
import axios from "axios";
import { UserRound, Save, ChevronDown, ChevronUp } from "lucide-react";
import { toast } from "sonner";
import { useLanguage } from "../i18n";
import { useAuth } from "../auth";
import { ProfileFields, mergeProfile } from "./ProfileFields";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ProfilePanel = () => {
  const { t } = useLanguage();
  const { user, setUser } = useAuth();
  const p = t.profile;
  const complete = Boolean(user?.profile?.user_type);
  const [open, setOpen] = useState(!complete);
  const [form, setForm] = useState(mergeProfile(user?.profile));
  const [busy, setBusy] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await axios.put(`${API}/me/profile`, form, { withCredentials: true });
      setUser(res.data);
      toast.success(p.saved);
      setOpen(false);
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : Array.isArray(d) ? d.map((x) => x.msg).join(" ") : "Errore");
    } finally {
      setBusy(false);
    }
  };

  const pr = user?.profile;
  return (
    <section data-testid="profile-panel" className="mt-12 bg-white border border-ink/10 rounded-sm p-8 shadow-[0_8px_30px_rgba(42,39,38,0.04)]">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <p className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-semibold text-amberdark"><UserRound className="w-4 h-4" strokeWidth={1.5} />{p.title}</p>
          {complete ? (
            <p data-testid="profile-summary" className="mt-2 text-sm text-inksoft">
              <span className="text-ink font-semibold">{pr.first_name} {pr.last_name}</span> · {p.types[pr.user_type] || pr.user_type}
              {pr.company_name && <> · {pr.company_name} ({pr.company_city})</>} · {p.segment}: <span className="text-ink">{pr.segment}</span>
            </p>
          ) : (
            <p data-testid="profile-incomplete" className="mt-2 text-sm text-amberdark">{p.incomplete}</p>
          )}
        </div>
        <button type="button" data-testid="profile-toggle" onClick={() => setOpen(!open)} className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.15em] border border-ink/20 hover:border-ink rounded-sm px-4 h-10 text-ink">
          {open ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}{open ? p.close : p.edit}
        </button>
      </div>
      {open && (
        <form data-testid="profile-form" onSubmit={save} className="mt-8 space-y-6">
          <ProfileFields value={form} onChange={setForm} invoiceMode="toggle" idPrefix="account-" />
          <button type="submit" data-testid="profile-save" disabled={busy} className="inline-flex items-center gap-2 bg-ink text-cream hover:bg-espresso disabled:opacity-60 rounded-sm px-6 h-11 text-xs font-semibold uppercase tracking-[0.15em]">
            <Save className="w-4 h-4" strokeWidth={1.5} />{p.save}
          </button>
        </form>
      )}
    </section>
  );
};
